import { ReactElement } from "react"
import { QueryClient, QueryClientProvider } from "react-query"
import {
    Navigate,
    Route,
    BrowserRouter as Router,
    Routes,
} from "react-router-dom"
import { AuthProvider, useAuth } from "./contexts/AuthContext"
import { ThemeProvider } from "./contexts/ThemeContext"
import CreditsPage from "./pages/CreditsPage"
import Dashboard from "./pages/Dashboard"
import DeviceListPage from "./pages/Devices"
import LoginPage from "./pages/LoginPage"
import NotFound from "./pages/NotFound"
import RegisterPage from "./pages/RegisterPage"
import ServersPage from "./pages/ServersPage"

// Componente para rotas protegidas
const ProtectedRoute = ({
    children,
    alt,
}: {
    children: ReactElement
    alt?: ReactElement
}) => {
    const { isAuthenticated, loading } = useAuth()

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
            </div>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    return children
}

const RedirectOrNotFound = () => {
    const { isAuthenticated } = useAuth()

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    return <NotFound />
}

export const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
})

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <AuthProvider>
                    <Router>
                    <Routes>
                        <Route path="*" element={<RedirectOrNotFound />} />

                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route
                            path="/"
                            element={<Navigate to="/dashboard" replace />}
                        />

                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/devices"
                            element={
                                <ProtectedRoute>
                                    <DeviceListPage />
                                </ProtectedRoute>
                            }
                        />
                        {/* "Adicionar dispositivo" virou modal da listagem. */}
                        <Route
                            path="/generate"
                            element={<Navigate to="/devices?add=1" replace />}
                        />
                        <Route
                            path="/servers"
                            element={
                                <ProtectedRoute>
                                    <ServersPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/credits"
                            element={
                                <ProtectedRoute>
                                    <CreditsPage />
                                </ProtectedRoute>
                            }
                        />
                        {/* Fase 3: /payments mockado foi substituído pela Carteira. */}
                        <Route
                            path="/payments"
                            element={<Navigate to="/credits" replace />}
                        />
                    </Routes>
                    </Router>
                </AuthProvider>
            </ThemeProvider>
        </QueryClientProvider>
    )
}

export default App
